
export class Chapter{

  title:String;
  time:number;
  
  constructor(object = null){

    if(object){
      this.set(object);
    }
  };

  set(object){
    if(object.title){
      this.title = object.title;
    }
    if(object.time != null){
      this.time = object.time;
    }
  }
}
  
  